import "./App.css";
import AgentSidebar from "./agent/AgentSidebar";
import AdminSidebar from "./admin/AdminSidebar";
import { Route, Routes } from "react-router-dom";
import AdminLogin from "./admin/components/AdminLogin";
import AgentLogin from "./agent/components/AgentLogin";
import { Outlet } from "react-router-dom";
import Admindashboard from "./admin/Pages/Dashboard";
import Agentdashboard from "./agent/Pages/Dashboard";
import Agents from "./admin/Pages/Agents";
import Agentdata from "./agent/Pages/Data";
import Admindata from "./admin/Pages/Data";
import Profile from "./agent/Pages/Profile";
import AdminProfile from "./admin/AdminProfile";
import Admindatadetail from "./admin/Pages/DataDetail";
import Adminupload from "./admin/Pages/Upload";
import Rooms from "./admin/Pages/Rooms";
import Agentdatadetail from "./agent/Pages/DataDetail";
import DeleteData from "./admin/Pages/Delete";
import AgentRooms from "./agent/Pages/AgentRooms";
import { SocketProvider } from "./contexts/SocketContext";
import SubAdminLogin from "./subadmin/components/SubAdminLogin";
import SubChatRoom from "./subadmin/components/SubChatRoom";
import Subadmins from "./admin/Pages/Subadmins"
import SubAdminSidebar from "./subadmin/SubAdminSidebar"
import SubRooms from "./subadmin/Pages/Rooms";
import SubAdminAgents from "./subadmin/Pages/Agents";
import SubProfile from "./subadmin/Pages/Profile";
const App = () => {
  return (
    <SocketProvider>
      <Routes>
        <Route path="admin" element={<AdminLogin />} />
        <Route
          path="admin"
          element={
            <div className="wrapper">
              <AdminSidebar />
              <div className="home_container">
                <Outlet />
              </div>
            </div>
          }
        >
          <Route path="dashboard" element={<Admindashboard />} />
          <Route path="agent" element={<Agents />} />
          <Route path="data" element={<Admindata />} />
          <Route path="detailed" element={<Admindatadetail />} />
          <Route path="upload" element={<Adminupload />} />
          <Route path="profile" element={<AdminProfile />} />
          <Route path="deletedata" element={<DeleteData />} />
          <Route path="rooms" element={<Rooms />} />
          <Route path="subadmin" element={<Subadmins />} />
        </Route>

        <Route path="agent" element={<AgentLogin />} />
        <Route
          path="agent"
          element={
            <div className="wrapper">
              <AgentSidebar />
              <div className="home_container">
                <Outlet />
              </div>
            </div>
          }
        >
          <Route path="dashboard" element={<Agentdashboard />} />
          <Route path="data" element={<Agentdata />} />
          <Route path="detailed" element={<Agentdatadetail />} />
          <Route path="profile" element={<Profile />} />
          <Route path="rooms" element={<AgentRooms />} />
        </Route>
        <Route path="subadmin" element={<SubAdminLogin />} />
        <Route
          path="subadmin"
          element={
            <div className="wrapper">
              <SubAdminSidebar />
              <div className="home_container">
                <Outlet />
              </div>
            </div>
          }
        >
          <Route path="profile" element={<SubProfile />} />
          <Route path="rooms" element={<SubRooms />} />
          <Route path="agent" element={<SubAdminAgents />} />
        </Route>
      </Routes>
    </SocketProvider>
  );
};

export default App;